"use client";

import React from "react";
import Image from "next/image";
import { Heading, Text } from "@/components/ui/typography";

export default function WhyMuteTaxes({ heading = "Why I Started MuteTaxes" }: { heading?: string } = {}) {
  return (
    <section className="w-full bg-black max-sm:px-0 px-4 lg:py-[100px]">
      <div className="mx-auto max-w-[1232px] max-sm:w-full max-sm:rounded-none max-sm:max-w-screen rounded-[32px] bg-[#0f1218] px-5 py-6 shadow-[0_0_0_1px_rgba(255,255,255,0.08)] sm:px-8 sm:py-8  max-sm:shadow-none lg:px-[60px] lg:py-[32px]">
        <Heading as="h2" variant="section">
          {heading}
        </Heading>

        <div className="mt-7 flex flex-col max-sm:flex-col-reverse gap-8 rounded-[28px] bg-[#0a0d12] border border-white/10 max-sm:px-3 max-sm:py-3 py-[30px] sm:px-10 sm:py-10 lg:mt-8 lg:min-h-[414px] lg:flex-row lg:items-center lg:justify-between lg:gap-10 lg:px-[30px] lg:py-[30px]">
          <div className="flex max-w-[610px] flex-col justify-center">
            <p className="font-suisse-intl text-[24px] max-sm:text-[18px] max-sm:leading-[25px] font-semibold leading-[160%] tracking-[-1px] text-white">
              &quot;Most formation providers only handled incorporation
              paperwork. MuteTaxes was built to fix that.&quot;
            </p>

            <div className="mt-10">
              <Heading as="h4" variant="cardTitle" className="max-sm:text-[18px] leading-[29px]">
                Ali Azhar
              </Heading>
              <Text variant="muted" className="leading-[29px]">
                Founder, MuteTaxes
              </Text>
            </div>
          </div>

          <div className="relative h-[280px] w-full overflow-hidden rounded-[22px] sm:h-[360px] lg:h-[354px] lg:w-[393px] lg:shrink-0">
            <Image
              src="/how-it-work/how-it-work-men.webp"
              alt="Ali Azhar, Founder of MuteTaxes"
              fill
              priority
              className="object-cover object-center"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
